enum ExportType {
  DIAGNOSTIC = "diagnostic",
}

export default ExportType;
